import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=bfb2d3c0&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=bfb2d3c0&prod&scoped=true&lang=css"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=bfb2d3c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb2d3c0",
  null
  
)

export default component.exports